(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    /* Milestone 5 fix: the Theme Editor replaces this section's HTML via
       AJAX whenever a setting changes, without reloading the page or
       re-running this script — so a header/logoBox captured once at
       load time goes stale (pointing at a detached DOM node) and the
       scroll effect appears to just stop working until a manual
       refresh. header/logoBox/config are now re-read by init(), called
       once on load and again on Shopify's shopify:section:load event;
       the actual scroll/resize listeners are registered exactly once
       and always read the current (closure-captured, reassignable)
       variables, so re-running init() doesn't pile up duplicate
       listeners. */
    var header, logoBox;
    var shrinkStart, shrinkEnd, forceShrunk, logoHideOnShrink, syncContentPadding;
    var headerHeightDesktop, headerHeightMobile, logoSizeMobile, logoSizeDesktop, logoBoxDesktop, bumpRadius;
    var aboveSticky, aboveSections = [], aboveHeight = 0, aboveBottomAbs = 0;
    var compensateAbove, compensateAdjust, compensateMin;

    function pair(name, fallback) {
      var raw = header.getAttribute('data-' + name);
      if (!raw) return fallback;
      var parts = raw.split(',');
      return [parseFloat(parts[0]), parseFloat(parts[1])];
    }

    function readConfig() {
      header = document.querySelector('.site-header');
      if (!header) return false;
      logoBox = document.querySelector('.site-header__center');

      var shrinkStartAttr = parseFloat(header.getAttribute('data-shrink-start'));
      var shrinkEndAttr = parseFloat(header.getAttribute('data-shrink-end'));
      shrinkStart = isNaN(shrinkStartAttr) ? 100 : shrinkStartAttr;
      shrinkEnd = isNaN(shrinkEndAttr) ? 200 : shrinkEndAttr;
      forceShrunk = header.hasAttribute('data-force-shrunk');
      logoHideOnShrink = header.getAttribute('data-logo-hide-on-shrink') !== 'false';
      syncContentPadding = header.hasAttribute('data-sync-content-padding');

      headerHeightDesktop = pair('header-h-desktop', [90, 64]);
      headerHeightMobile = pair('header-h-mobile', [90, 64]);
      logoSizeMobile = pair('logo-mobile', [56, 36]);
      logoSizeDesktop = pair('logo-desktop', [130, 44]);
      logoBoxDesktop = pair('badge', [170, 60]);
      bumpRadius = pair('bump-depth', [85, 0]);
      aboveSticky = header.getAttribute('data-above-header') !== 'scroll';
      compensateAbove = header.getAttribute('data-compensate-above') === 'true';
      compensateAdjust = pair('compensate-adjust', [0, 0]);
      compensateMin = parseFloat(header.getAttribute('data-compensate-min')) || 44;
      return true;
    }

    /* ── Banners / sections above the header ──────────────────────
       .site-header is position:fixed, so anything else rendered at the
       top of the page sits hidden underneath it. Two kinds are handled:

       1. In-flow content before #MainContent: every other header-group
          section (announcement bar, an Apps section holding a banner
          app — in ANY order relative to the header, since the header's
          own wrapper takes no flow space and a section listed after it
          would still land at y:0), plus anything an app's script
          inserts at the top of <body>. Their combined height pushes the
          header down. "sticky" also pins them to the top (stacked at
          cumulative offsets); "scroll" leaves them in flow and update()
          slides the header up as they scroll away.
       2. Banners an app pins to the top of the viewport itself
          (position:fixed, top:0, full width). They're always visible,
          so their height is a constant extra offset.

       The header's offset is --header-offset-top. Collected on load,
       editor section changes and <body> child insertions (apps inject
       late); measured on resize. Nothing here runs per scroll frame. */
    var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, LINK: 1, NOSCRIPT: 1, TEMPLATE: 1, META: 1 };
    var fixedBanners = [], fixedHeight = 0;

    function collectAboveSections() {
      aboveSections.forEach(function (el) {
        if (!el.hasAttribute('data-header-pinned')) return;
        el.removeAttribute('data-header-pinned');
        el.style.position = '';
        el.style.top = '';
        el.style.zIndex = '';
      });
      aboveSections = [];
      fixedBanners = [];
      var wrapper = header.closest('.shopify-section');
      var main = document.getElementById('MainContent');
      var beforeMain = true;
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (el === main || (main && el.contains(main))) {
          beforeMain = false;
          return;
        }
        if (el === wrapper || SKIP_TAGS[el.tagName]) return;
        var cs = window.getComputedStyle(el);
        if (cs.position === 'fixed') {
          fixedBanners.push(el);
        } else if (beforeMain && cs.position !== 'absolute') {
          aboveSections.push(el);
        }
      });
      if (aboveResizeObserver) {
        aboveResizeObserver.disconnect();
        aboveSections.concat(fixedBanners).forEach(function (s) { aboveResizeObserver.observe(s); });
      }
    }

    function isVisible(el, cs) {
      return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0;
    }

    function measureAboveSections() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;

      fixedHeight = 0;
      fixedBanners.forEach(function (el) {
        var cs = window.getComputedStyle(el);
        if (!isVisible(el, cs)) return;
        var r = el.getBoundingClientRect();
        // Only a top bar: flush with the viewport top, (nearly) full
        // width, and short — not a drawer, modal or cookie popup.
        if (r.top <= 1 && r.bottom > 0 && r.width >= window.innerWidth * 0.9 && r.height <= window.innerHeight * 0.4) {
          fixedHeight = Math.max(fixedHeight, r.bottom);
        }
      });

      var offset = fixedHeight;
      var last = null;
      aboveSections.forEach(function (el) {
        var cs = window.getComputedStyle(el);
        if (!isVisible(el, cs)) return;
        var h = el.getBoundingClientRect().height;
        if (!h) return;
        var pinnable = cs.position === 'static' || cs.position === 'relative' || el.hasAttribute('data-header-pinned');
        if (pinnable && (aboveSticky || compensateAbove)) {
          el.setAttribute('data-header-pinned', '');
          if (aboveSticky) {
            el.style.position = 'sticky';
            el.style.top = offset + 'px';
          } else {
            // Scrolls away, but #MainContent is pulled up underneath it
            // when compensating (see update()), so it still has to paint
            // above the page.
            el.style.position = 'relative';
          }
          // Below .site-header (999) so the header's own drawer/overlays
          // still win, and below Dawn's cart drawer (1000).
          el.style.zIndex = '998';
        }
        offset += h;
        last = el;
      });
      aboveHeight = offset - fixedHeight;
      aboveBottomAbs = last ? last.getBoundingClientRect().bottom + scrollY : 0;
    }

    var recollectQueued = false;
    function recollect() {
      if (recollectQueued) return;
      recollectQueued = true;
      window.requestAnimationFrame(function () {
        recollectQueued = false;
        if (!header) return;
        collectAboveSections();
        remeasureAndUpdate();
      });
    }

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktopMQ = window.matchMedia('(min-width: 990px)');

    function lerp(range, p) {
      return range[0] + (range[1] - range[0]) * p;
    }

    /* ── Desktop nav center-distribution ──────────────────────────
       CSS space-between distributes flex ITEM edges evenly, not label
       CENTERS — with differently-sized labels those diverge. Instead:
       for N labels across an interval [A, B], center(i) = A + i/(N+1)
       * (B-A) for i = 1..N (equal spacing between every center AND
       from the boundary to the first/last center).

       Boundaries:
       - Left group: A = the nav container's own left edge (already
         past the header's own side padding — no separate math needed
         for that). B = the logo's left edge.
       - Right group: A = the logo's right edge. B = the icons
         container's left edge (icons stay anchored, never move).
       - Shrunk state: per spec, the reference shifts from the logo's
         edge to the true page center instead, continuously — B (left
         group) / A (right group) is lerp(logoEdge, headerCenterX, p),
         reusing the same --header-p already driving everything else,
         so it's one consistent interpolation instead of a separate
         shrunk/unshrunk branch.

       Performance: getBoundingClientRect() forces a layout read, which
       is too expensive to do every scroll frame for multiple elements.
       Only the logo's width changes during scroll (already computed,
       no DOM read needed — logoBoxDesktop lerp result is passed in);
       the header, icons, containers, and each label's own width don't
       change shape during scroll, so those are measured once in
       measureNav() (on init/resize/font-load) and cached; layoutNav()
       itself (called every scroll frame from update()) does pure
       arithmetic plus style writes, no DOM reads. */
    var navCache = null; // set by measureNav()

    function collectLinks(container) {
      return Array.prototype.slice.call(container.querySelectorAll('.site-header__nav-link'));
    }

    function measureNav() {
      if (!header || !desktopMQ.matches) {
        navCache = null;
        return;
      }
      var leftContainer = header.querySelector('.site-header__nav--left');
      var rightContainer = header.querySelector('.site-header__nav--right');
      var iconsEl = header.querySelector('.site-header__icons');
      if (!leftContainer || !rightContainer || !iconsEl) {
        navCache = null;
        return;
      }

      var headerRect = header.getBoundingClientRect();
      var leftRect = leftContainer.getBoundingClientRect();
      var rightRect = rightContainer.getBoundingClientRect();
      var iconsRect = iconsEl.getBoundingClientRect();

      var leftLinks = collectLinks(leftContainer).map(function (el) {
        return { el: el, width: el.getBoundingClientRect().width, offset: parseFloat(el.getAttribute('data-offset-x')) || 0 };
      });
      var rightLinks = collectLinks(rightContainer).map(function (el) {
        return { el: el, width: el.getBoundingClientRect().width, offset: parseFloat(el.getAttribute('data-offset-x')) || 0 };
      });

      navCache = {
        headerCenterX: (headerRect.left + headerRect.right) / 2,
        leftContainerLeft: leftRect.left,
        rightContainerLeft: rightRect.left,
        iconsLeft: iconsRect.left,
        leftLinks: leftLinks,
        rightLinks: rightLinks
      };
    }

    function distributeCenters(links, a, b, containerLeft) {
      var n = links.length;
      if (n === 0) return;
      links.forEach(function (link, index) {
        var t = (index + 1) / (n + 1);
        var centerX = a + t * (b - a) + link.offset;
        var left = centerX - containerLeft - link.width / 2;
        link.el.style.left = left.toFixed(2) + 'px';
      });
    }

    function layoutNav(p, currentLogoBoxWidth) {
      if (!navCache) return;

      var logoLeft = navCache.headerCenterX - currentLogoBoxWidth / 2;
      var logoRight = navCache.headerCenterX + currentLogoBoxWidth / 2;

      var leftBoundaryRight = lerp([logoLeft, navCache.headerCenterX], p);
      var rightBoundaryLeft = lerp([logoRight, navCache.headerCenterX], p);

      distributeCenters(navCache.leftLinks, navCache.leftContainerLeft, leftBoundaryRight, navCache.leftContainerLeft);
      distributeCenters(navCache.rightLinks, rightBoundaryLeft, navCache.iconsLeft, navCache.rightContainerLeft);

      // Links are invisible (see CSS) until their first real `left` is
      // written above — reveal only now, already correctly positioned,
      // instead of showing them at their default spot and visibly
      // sliding them into place.
      header.classList.add('site-header--nav-ready');
    }

    var ticking = false;

    function update() {
      if (!header) return;

      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      var raw = (scrollY - shrinkStart) / (shrinkEnd - shrinkStart);
      var p = Math.max(0, Math.min(1, raw));

      // Reduced motion: snap to expanded/shrunk instead of continuously
      // tracking scroll position, so there's one state change instead of
      // ongoing motion, without ignoring scroll position altogether.
      if (reducedMotion.matches) {
        p = Math.round(p);
      }

      // Non-home pages have no hero to sit behind, so the header stays
      // locked to its shrunk state regardless of scroll position — see
      // data-force-shrunk and the #MainContent padding-top rule above.
      if (forceShrunk) {
        p = 1;
      }

      var offsetTop = fixedHeight + (aboveSticky ? aboveHeight : Math.max(0, aboveBottomAbs - scrollY));
      header.style.setProperty('--header-offset-top', offsetTop.toFixed(2) + 'px');

      var currentLogoBoxWidth = lerp(logoBoxDesktop, p);
      var currentHeaderHeightDesktop = lerp(headerHeightDesktop, p);
      var currentHeaderHeightMobile = lerp(headerHeightMobile, p);

      /* "Garder la même hauteur totale avec une bannière": the header
         alone is H tall; with a banner of height B above it the top of
         the page would be covered by B + H. Shrink the header to H - B
         (+ the per-device adjustment, floored at the minimum) so
         banner + header covers the same height as the header alone.
         Logo sizes scale by the same ratio so the logo still fits. */
      var logoScaleDesktop = 1;
      var logoScaleMobile = 1;
      var compensating = compensateAbove && offsetTop > 0;
      if (compensating) {
        var compDesktop = Math.max(compensateMin, currentHeaderHeightDesktop - offsetTop + compensateAdjust[0]);
        var compMobile = Math.max(compensateMin, currentHeaderHeightMobile - offsetTop + compensateAdjust[1]);
        logoScaleDesktop = Math.min(1, compDesktop / currentHeaderHeightDesktop);
        logoScaleMobile = Math.min(1, compMobile / currentHeaderHeightMobile);
        currentHeaderHeightDesktop = compDesktop;
        currentHeaderHeightMobile = compMobile;
        currentLogoBoxWidth *= logoScaleDesktop;
      }

      header.style.setProperty('--header-h-desktop', currentHeaderHeightDesktop.toFixed(2) + 'px');
      header.style.setProperty('--header-h-mobile', currentHeaderHeightMobile.toFixed(2) + 'px');
      header.style.setProperty('--logo-size-mobile', (lerp(logoSizeMobile, p) * logoScaleMobile).toFixed(2) + 'px');
      header.style.setProperty('--logo-size-desktop', (lerp(logoSizeDesktop, p) * logoScaleDesktop).toFixed(2) + 'px');
      header.style.setProperty('--logo-box-desktop', currentLogoBoxWidth.toFixed(2) + 'px');
      header.style.setProperty('--bump-radius', lerp(bumpRadius, p).toFixed(2) + 'px');
      header.style.setProperty('--header-p', p.toFixed(4));

      // The in-flow banner would push the whole page down by its own
      // height; pull #MainContent back up underneath it so the page
      // starts exactly where it does without a banner.
      var mainEl = document.getElementById('MainContent');
      if (mainEl) {
        mainEl.style.marginTop = compensating && aboveHeight ? '-' + aboveHeight.toFixed(2) + 'px' : '';
      }

      // "Jamais superposé (animé)": the header keeps animating instead
      // of being locked shrunk, so #MainContent's padding-top has to
      // track its actual current height every frame — a static value
      // would either leave a gap or, worse, let the expanded header
      // cover content again.
      // A viewport-fixed app banner takes no flow space either, so in
      // the non-overlay modes it's added to the content push too.
      // When compensating, the push is the whole banner + header stack
      // (main was pulled up to y:0 above).
      if (syncContentPadding || (forceShrunk && (fixedHeight || compensating))) {
        var mainContent = document.getElementById('MainContent');
        if (mainContent) {
          var currentHeight = desktopMQ.matches ? currentHeaderHeightDesktop : currentHeaderHeightMobile;
          var extra = compensating ? offsetTop : fixedHeight;
          mainContent.style.paddingTop = (currentHeight + extra).toFixed(2) + 'px';
        }
      }

      if (logoBox) {
        // Only strip pointer-events when the logo is actually configured
        // to fade away — if it stays visible (logoHideOnShrink false) it
        // must stay clickable too.
        logoBox.classList.toggle('header--logo-hidden', logoHideOnShrink && p >= 0.98);
      }

      layoutNav(p, currentLogoBoxWidth);

      // .site-header is position:fixed with top:0, so its rendered
      // bottom edge is always exactly its own height — no need to ask
      // the browser via getBoundingClientRect(), which would force a
      // synchronous layout recalculation on every single scroll frame
      // (right after several style writes above, the worst possible
      // spot for one). Desktop CPUs mostly absorb that cost without a
      // visibly dropped frame; phones don't — this was the main source
      // of scroll jank on mobile.
      var currentHeaderBottom = (desktopMQ.matches ? currentHeaderHeightDesktop : currentHeaderHeightMobile) + offsetTop;
      setDrawerVars(currentHeaderBottom);

      ticking = false;
    }

    /* Dawn's menu-drawer CSS sizes the mobile drawer panel off
       --header-bottom-position / --viewport-height. The old HeaderDrawer
       subclass used to set these from .section-header/.header-wrapper,
       which this rebuild no longer has, so this header sets them itself.
       Called from update() too (not just resize/load) since the header's
       actual height now changes continuously with scroll position. */
    function setDrawerVars(currentHeaderBottom) {
      if (!header) return;
      document.documentElement.style.setProperty('--header-bottom-position', Math.round(currentHeaderBottom) + 'px');
      document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    function remeasureAndUpdate() {
      measureAboveSections();
      measureNav();
      // update() computes the current header height and calls
      // setDrawerVars() itself with a real value — no separate call
      // needed here.
      update();
    }

    window.addEventListener('resize', remeasureAndUpdate);
    desktopMQ.addEventListener('change', remeasureAndUpdate);
    reducedMotion.addEventListener('change', update);

    /* ResizeObserver on .site-header itself (not document.body, which
       would over-fire on unrelated page content height changes) —
       .site-header is position:fixed so its width tracks the viewport,
       catching width changes a plain window "resize" event might miss
       (e.g. scrollbar show/hide) without reacting to irrelevant page
       height changes elsewhere. Re-created (not just re-observed) in
       init() because header is reassigned to a new DOM node on
       shopify:section:load — an observer watching the old, now-detached
       node would silently stop firing otherwise, same stale-reference
       class of bug fixed earlier for header/logoBox themselves. */
    var headerResizeObserver = window.ResizeObserver ? new ResizeObserver(remeasureAndUpdate) : null;
    // Banner apps often render late / change height (e.g. text rotating,
    // dismiss button), so the sections above are watched too.
    var aboveResizeObserver = window.ResizeObserver ? new ResizeObserver(remeasureAndUpdate) : null;

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(remeasureAndUpdate);
    }

    function init() {
      if (!readConfig()) return;
      collectAboveSections();
      if (headerResizeObserver) {
        headerResizeObserver.disconnect();
        headerResizeObserver.observe(header);
      }
      remeasureAndUpdate();
    }

    init();
    document.addEventListener('shopify:section:load', init);
    // Adding/removing/reordering sections in the editor changes what's
    // above the header. unload fires before the node is removed, hence
    // the deferred re-init.
    document.addEventListener('shopify:section:unload', function () { setTimeout(init, 0); });
    document.addEventListener('shopify:section:reorder', init);
    // Banner apps typically inject their bar into <body> with their own
    // script after load (or remove it when dismissed).
    if (window.MutationObserver) {
      new MutationObserver(recollect).observe(document.body, { childList: true });
    }
    // Some apps restyle their bar (e.g. switch it to position:fixed)
    // after inserting it; a late second pass catches that.
    window.addEventListener('load', function () { setTimeout(recollect, 500); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["installation-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', function (event) {
    const panel = event.target.closest('.jig-installation__accordion');
    if (panel) panel.open = true;
  });


  // Survives theme-editor re-renders: selected category, open state and selected block per panel.
  window.jigInstallationState = window.jigInstallationState || {};
  function jigPanelState(panel) {
    return (window.jigInstallationState[panel.id] = window.jigInstallationState[panel.id] || {});
  }
  function jigMechanismMatches(restriction, selection) {
    const path = !restriction || restriction === 'all' ? 'handle' : restriction;
    return path === selection;
  }
  // Stops a video still playing in the option the customer just switched away from.
  function jigStopMedia(container) {
    container.querySelectorAll('video').forEach(function (video) { video.pause(); });
    container.querySelectorAll('iframe').forEach(function (iframe) { iframe.src = iframe.src; });
  }
  function updateJigInstallation(panel, selection) {
    const state = jigPanelState(panel);
    // '' = nothing chosen yet: only the Poignée / Cames buttons are shown.
    const mechanism = selection || panel.dataset.jigSelectedMechanism || state.mechanism || panel.dataset.jigDefault || '';
    const ready = panel.dataset.jigReady === 'true';
    panel.dataset.jigSelectedMechanism = mechanism;
    state.mechanism = mechanism;
    panel.querySelectorAll('[data-jig-mechanism-button]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.jigMechanismButton === mechanism));
    });
    panel.querySelectorAll('[data-jig-option-panel]').forEach(function (optionPanel) {
      const show = optionPanel.dataset.jigOptionPanel === mechanism;
      if (ready && !show && !optionPanel.hidden) jigStopMedia(optionPanel);
      optionPanel.hidden = !show;
    });
    const camsPhoto = panel.querySelector('[data-jig-cams-photo]');
    if (camsPhoto) camsPhoto.hidden = mechanism !== 'cams';
    let count = 0;
    panel.querySelectorAll('[data-jig-step]').forEach(function (step) {
      const show = jigMechanismMatches(step.dataset.mechanism, mechanism);
      step.hidden = !show;
      if (show) {
        count += 1;
        step.querySelector('[data-jig-step-number]').textContent = count;
      }
      let subCount = 0;
      step.querySelectorAll('[data-jig-substep]').forEach(function (substep) {
        const subShow = show && jigMechanismMatches(substep.dataset.mechanism, mechanism);
        substep.hidden = !subShow;
        if (subShow) {
          subCount += 1;
          substep.querySelector('[data-jig-substep-number]').textContent = count + '.' + subCount;
        }
      });
      const subList = step.querySelector('.jig-installation__substeps');
      if (subList) subList.hidden = subCount === 0;
    });
    const empty = panel.querySelector('[data-jig-empty]');
    if (empty) empty.hidden = !mechanism || count > 0;
    panel.dataset.jigReady = 'true';
  }
  function initializeJigInstallations(scope) {
    scope.querySelectorAll('[data-jig-installation]').forEach(function (panel) { updateJigInstallation(panel); });
  }
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-jig-mechanism-button]');
    if (!button) return;
    const panel = button.closest('[data-jig-installation]');
    if (panel) updateJigInstallation(panel, button.dataset.jigMechanismButton);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-jig-installation]').forEach(function (panel) {
      jigPanelState(panel).open = panel.open;
    });
  });
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-jig-installation]').forEach(function (panel) {
      const state = jigPanelState(panel);
      let mechanism = state.mechanism;
      // A block whose category was just changed: follow it to its new category.
      const selected = state.blockId && panel.querySelector('[data-block-id="' + state.blockId + '"]');
      if (selected) mechanism = selected.dataset.mechanism === 'cams' ? 'cams' : 'handle';
      if (state.open || selected) panel.open = true;
      updateJigInstallation(panel, mechanism);
    });
  });
  document.addEventListener('shopify:block:select', function (event) {
    const panel = event.target.closest('[data-jig-installation]');
    if (!panel) return;
    const step = event.target.closest('[data-jig-step]');
    const substep = event.target.closest('[data-jig-substep]');
    if (!step) return;
    jigPanelState(panel).blockId = event.detail && event.detail.blockId;
    let mechanism = panel.dataset.jigSelectedMechanism || 'handle';
    [step, substep].filter(Boolean).forEach(function (item) {
      mechanism = item.dataset.mechanism === 'cams' ? 'cams' : 'handle';
    });
    panel.open = true;
    updateJigInstallation(panel, mechanism);
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    const panel = event.target.closest('[data-jig-installation]');
    if (panel) jigPanelState(panel).blockId = null;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeJigInstallations(document); });
  else initializeJigInstallations(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pickClosestVariant(variants, targetWidth) {
      var best = null;
      var bestDiff = Infinity;
      for (var i = 0; i < variants.length; i++) {
        var diff = Math.abs(variants[i].width - targetWidth);
        if (diff < bestDiff) {
          bestDiff = diff;
          best = variants[i];
        }
      }
      return best;
    }

    function setUpVideo(root) {
      var video = root.querySelector('video');
      if (!video) return;

      var variants = [];
      try {
        variants = JSON.parse(root.getAttribute('data-video-variants') || '[]');
      } catch (e) {
        variants = [];
      }
      if (!variants.length) return;

      var chosen = pickClosestVariant(variants, window.innerWidth);
      if (chosen) {
        video.src = chosen.src;
      }

      var speed = parseFloat(root.getAttribute('data-playback-speed')) || 1;

      var applySpeed = function () {
        video.playbackRate = speed;
      };

      // Some browsers reset playbackRate to 1 right as playback starts,
      // so set it both as soon as metadata is available AND again on
      // the first 'play' event, rather than only once on load.
      video.addEventListener('loadedmetadata', applySpeed, { once: true });
      video.addEventListener('play', applySpeed);

      // The HTML autoplay attribute reliably starts playback for video
      // present in the initial page HTML, but this <video> starts with
      // no src at all (it's set above, after picking the closest
      // variant) and browsers don't reliably autoplay a src assigned
      // via script — nor do they honor autoplay for a <video> inserted
      // afterward via innerHTML, which is what happens on every Theme
      // Editor settings change. Calling play() explicitly covers all
      // of that; catch() silently no-ops if a browser's autoplay
      // policy still blocks it (muted+playsinline already satisfy
      // every major browser's policy, so this should only ever fire as
      // a rare fallback, not the normal path).
      video.load();
      var playResult = video.play();
      if (playResult && typeof playResult.catch === 'function') {
        playResult.catch(function () {});
      }
    }

    function init(container) {
      container.querySelectorAll('[data-video-hero]').forEach(setUpVideo);
    }

    init(document);

    // Theme Editor replaces this section's HTML via AJAX on every
    // settings change without reloading the page, so re-apply to the
    // freshly-inserted markup instead of only running once on load.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
